import { render, staticRenderFns } from "./FeedbackFilter.vue?vue&type=template&id=b0a8edd6&scoped=true&"
import script from "./FeedbackFilter.vue?vue&type=script&lang=js&"
export * from "./FeedbackFilter.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFilter.vue?vue&type=style&index=0&id=b0a8edd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a8edd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow})
